// קומפוננטת לוגו פשוטה
export  const Logo = ({ size = 100 }) => (
  <div style={{ textAlign: 'center', marginBottom: '20px' }}>
    <img 
      src="/logo.svg"  // ← שנה לנתיב שלך
      alt="לוגו" 
      style={{ 
        width: size, 
        height: 'auto',
        borderRadius: '12px'  // אופציונלי
      }} 
    />
  </div>
);